import { post } from './request'

export function alarmList(data) {
  return post('/api/Alarm/List', data)
}
